/**
 * config/killchain.js
 * Lockheed Martin Kill Chain stages and mapping
 */

// ── Kill Chain Stages ─────────────────────────────────────────────────────────

export const KILL_CHAIN_STAGES = [
  "Reconnaissance", "Weaponization", "Delivery",
  "Exploitation", "Installation", "Command & Control", "Actions on Objectives"
];

export const KILL_CHAIN_MAP = {
  "Reconnaissance":  0,
  "Initial Access":  2,
  "Execution":       3,
  "Persistence":     4,
  "Credential Access": 3,
  "Discovery":       1,
  "Lateral Movement": 5,
  "Command & Control": 5,
  "Exfiltration":    6,
  "Impact":          6,
  "Defense Evasion": 3,
};

export const getKillChainStage = (tactic) =>
  KILL_CHAIN_MAP[tactic] ?? 0;
